export function LocationIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M6 10a6 6 0 1112 0c0 .778-.259 1.809-.737 2.969-.472 1.143-1.127 2.34-1.847 3.429-.722 1.091-1.49 2.044-2.176 2.71a5.486 5.486 0 01-.89.727c-.218.134-.329.16-.35.164-.021-.005-.132-.03-.35-.164a5.486 5.486 0 01-.89-.727c-.686-.666-1.454-1.619-2.176-2.71-.72-1.089-1.375-2.286-1.847-3.43C6.259 11.809 6 10.779 6 10zm6-8a8 8 0 00-8 8c0 1.155.366 2.466.888 3.731.528 1.281 1.248 2.593 2.028 3.77.778 1.176 1.635 2.249 2.45 3.04a7.43 7.43 0 001.234.996c.39.241.878.463 1.4.463.522 0 1.01-.222 1.4-.463.411-.254.828-.6 1.235-.995.814-.792 1.671-1.865 2.449-3.04.78-1.178 1.5-2.49 2.028-3.771.522-1.265.888-2.576.888-3.731a8 8 0 00-8-8zm2 8a2 2 0 10-4 0 2 2 0 004 0zm2 0a4 4 0 11-8 0 4 4 0 018 0z"
      ></path>
    </svg>
  );
}
